
import { useTranslation } from 'react-i18next';

export default function TestimonialsSection() {
  const { t } = useTranslation();

  const testimonials = [
    { nameKey: 'testimonials.t1.name', roleKey: 'testimonials.t1.role', contentKey: 'testimonials.t1.content', avatar: 'https://raphael.app/testimonials/sophie-miller.webp' },
    { nameKey: 'testimonials.t2.name', roleKey: 'testimonials.t2.role', contentKey: 'testimonials.t2.content', avatar: 'https://raphael.app/testimonials/michael-chen.webp' },
    { nameKey: 'testimonials.t3.name', roleKey: 'testimonials.t3.role', contentKey: 'testimonials.t3.content', avatar: 'https://raphael.app/testimonials/sarah-wang.webp' },
    { nameKey: 'testimonials.t4.name', roleKey: 'testimonials.t4.role', contentKey: 'testimonials.t4.content', avatar: 'https://raphael.app/testimonials/david-liu.webp' },
    { nameKey: 'testimonials.t5.name', roleKey: 'testimonials.t5.role', contentKey: 'testimonials.t5.content', avatar: 'https://raphael.app/testimonials/emma-zhang.webp' },
    { nameKey: 'testimonials.t6.name', roleKey: 'testimonials.t6.role', contentKey: 'testimonials.t6.content', avatar: 'https://raphael.app/testimonials/kevin-wu.webp' },
  ];

  return (
    <section className="py-24 lg:py-40 bg-[#1a1b1e] relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-20">
          <span className="inline-block px-5 py-2.5 bg-[#252830] border border-gray-700 rounded-full text-base font-bold mb-5 text-gray-300">
            {t('testimonials.badge')}
          </span>
          <h2 className="text-5xl lg:text-6xl font-display font-black text-white mb-8">
            {t('testimonials.title')}
          </h2>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto mb-4 font-semibold">
            {t('testimonials.subtitle')}
          </p>
          <p className="text-base text-gray-500 font-bold">
            {t('testimonials.ratings')}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-[#252830] rounded-2xl p-10 shadow-lg hover:shadow-2xl transition-all duration-300 border-2 border-gray-800 hover:border-primary/30"
            >
              <div className="flex items-center gap-4 mb-7">
                <img
                  src={testimonial.avatar}
                  alt={t(testimonial.nameKey)}
                  className="w-14 h-14 rounded-full object-cover border-2 border-gray-700"
                />
                <div>
                  <div className="font-black text-white text-base">{t(testimonial.nameKey)}</div>
                  <div className="text-sm text-gray-400 font-semibold">{t(testimonial.roleKey)}</div>
                </div>
              </div>
              <div className="flex gap-1 mb-5">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-accent text-base"></i>
                ))}
              </div>
              <p className="text-gray-300 leading-relaxed text-base font-medium">
                {t(testimonial.contentKey)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
